<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >
              {{ $t("dashboard.consentdetail") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card>
              <v-card-title>
                <v-layout row wrap justify-center>
                  <v-flex xs10 lg3 ml-4
                    ><b>{{ head }}</b
                    ><br /><br />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <!-- <v-flex xs7 lg4 justify-center>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex> -->
                </v-layout>
              </v-card-title>
              <v-data-table
                :search="Search"
                :headers="headers"
                :items="DetailDashboard"
                hide-default-footer
                :items-per-page="ItemPerPage"
              >
                <template v-slot:[`item.SendId`]="{ item }">
                  <div class="text-left">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          color="#077893"
                          style="cursor: pointer"
                          small
                          @click="Fn_CopyDetail(item.SendId)"
                          v-on="on"
                          >mdi-file-multiple-outline</v-icon
                        >
                        <!-- :page.sync="Page" @page-count="PageCount = $event" -->
                      </template>
                      <span>{{ $t("consentlist.copy") }}</span>
                    </v-tooltip>
                    {{ item.SendId }}
                  </div>
                </template>
                <template v-slot:[`item.BusinessName`]="{ item }">
                  <div v-if="$t('default') === 'th'">
                    {{ item.BusinessNameTh }}
                  </div>
                  <div v-else>
                    {{ item.BusinessNameEng }}
                  </div>
                </template>
                <template v-slot:[`item.PolicyHeader`]="{ item }">
                  {{ item.PolicyHeader }}
                </template>
                <template v-slot:[`item.SendAt`]="{ item }">
                  <div v-if="$t('default') === 'th'">
                    {{ item.SendAt }}
                  </div>
                  <div v-else>
                    {{ item.SendAtEng }}
                  </div>
                </template>
                <template v-slot:[`item.Type`]="{ item }">
                  <div v-if="item.Type === 'Group'">
                    {{ $t("dashboard.groupType") }}
                  </div>
                  <div v-else-if="item.Type === 'General'">
                    {{ $t("dashboard.generalType") }}
                  </div>
                </template>
                <template v-slot:[`item.Status`]="{ item }">
                  <div v-if="item.Status === 'active'">
                    <v-chip color="green" small dark>
                      {{ $t("petition.text22v2") }}</v-chip
                    >
                  </div>
                  <div v-else-if="item.Status === 'unactive'">
                    <v-chip color="grey" small dark>
                      {{ $t("petition.text23") }}</v-chip
                    >
                  </div>
                  <div v-else-if="item.Status === 'expire'">
                    <v-chip color="black" small dark>
                      {{ $t("petition.text37") }}</v-chip
                    >
                  </div>
                  <div v-else>
                    <v-chip color="warning" small dark>
                      {{ $t("petition.text24") }}</v-chip
                    >
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn
                        dark
                        v-bind="attrs"
                        v-on="on"
                        small
                        class="mx-2"
                        icon
                        color="#077893"
                        @click="Fn_ViewDetail(item)"
                      >
                        <v-icon dark size="20">
                          mdi-text-box-search-outline
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </template>
              </v-data-table>
              <v-pagination
                :total-visible="7"
                class="pt-2 pb-2"
                circle
                color="#077893"
                v-model="Page"
                :length="PageCount"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="changePage"
              >
              </v-pagination>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
// import 'sweetalert2/src/sweetalert2.scss'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      loadingDownloadData: false,
      disabled: false,
      Type: "",
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      DetailDashboard: [],
      head: "",
      SourceSystem: "",
      Search: "",
      Offset: 0,
    };
  },
  computed: {
    ...mapGetters(["DataPolicy"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    headers() {
      return [
        {
          text: this.$i18n.t("consentlist.Cnumber"),
          align: "center",
          value: "SendId",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("consentlist.type"),
          align: "center",
          value: "SourceSystem",
          sortable: false,
          width: "5%",
        },
        {
          text: this.$i18n.t("consentlist.topic"),
          value: "PolicyHeader",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("consentlist.infomation"),
          value: "Information",
          align: "center",
          sortable: false,
          width: "15%",
        },
        {
          text: this.$i18n.t("consentlist.type"),
          value: "Type",
          align: "center",
          sortable: false,
          width: "10%",
        },
        {
          text: this.$i18n.t("consentlist.date"),
          value: "SendAt",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("petition.text14"),
          value: "Status",
          align: "center",
          sortable: false,
          width: "10%",
        },
        {
          text: this.$i18n.t("consentlist.choicedetail"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    if (
      this.$cookies.get("DetailDashbord") == "API" ||
      this.$cookies.get("DetailDashbord") == "Webscript" ||
      this.$cookies.get("DetailDashbord") == "Email" ||
      this.$cookies.get("DetailDashbord") == "Onechat" ||
      this.$cookies.get("DetailDashbord") == "PDF"
    ) {
      this.GetDetailSourceSystem();
    } else {
      this.GetDetailDashboard();
    }
  },
  methods: {
    async GetDetailDashboard() {
      if (this.$cookies.get("DetailDashbord") == "ความยินยอมทั้งหมด") {
        this.Type = "All";
        this.head = this.$t("dashboard.total");
      } else if (this.$cookies.get("DetailDashbord") == "ความยินยอมทั่วไป") {
        this.Type = "General";
        this.head = this.$t("consentlist.generalconsent");
      } else if (this.$cookies.get("DetailDashbord") == "ความยินยอมแบบกลุ่ม") {
        this.Type = "Group";
        this.head = this.$t("consentlist.groupconsent");
      }
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        // AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        Type: this.Type,
        Limit: "10",
        Offset: this.Offset,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "dashbord/DetailDashbord",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            var countConsent = this.$cookies.get("CountDashbord");
            countConsent = parseInt(countConsent);
            this.DetailDashboard = response.data.Message;
            this.PageCount = Math.ceil(countConsent / this.ItemPerPage);

            var index = 0;
            for (var item of this.DetailDashboard) {
              index += 1;
              item.no = index;
            }

          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async GetDetailSourceSystem() {
      if (this.$cookies.get("DetailDashbord") == "API") {
        this.SourceSystem = "API";
        this.head = "API";
      } else if (this.$cookies.get("DetailDashbord") == "Email") {
        this.SourceSystem = "EMAIL";
        this.head = "Email";
      } else if (this.$cookies.get("DetailDashbord") == "Onechat") {
        this.SourceSystem = "ONECHAT";
        this.head = "Onechat";
      } else if (this.$cookies.get("DetailDashbord") == "Webscript") {
        this.SourceSystem = "Webscript";
        this.head = "Webscript";
      } else if (this.$cookies.get("DetailDashbord") == "PDF") {
        this.SourceSystem = "PDF";
        this.head = "PDF";
      }

      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        // AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        SourceSystem: this.SourceSystem,
        Limit: "10",
        Offset: this.Offset,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "dashbord/DetailDashbordSourceSystem",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            var countConsent = this.$cookies.get("CountDashbord");
            countConsent = parseInt(countConsent);
            this.DetailDashboard = response.data.Message;
            this.PageCount = Math.ceil(countConsent / this.ItemPerPage);

            var index = 0;
            for (var item of this.DetailDashboard) {
              index += 1;
              item.no = index;
            }
   
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_ViewDetail(item) {

      this.$router.push("/consent-dashboard");
      this.$store.dispatch("SET_DATA_GENERAL_CONSENT", item);
    },
    Fn_BackIndex() {
      this.$router.push("/dashboard");
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    async changePage(page) {

      page -= 1;
      var countPage = page * 10;

      this.Offset = countPage;
      if (
        this.head == "API" ||
        this.head == "PDF" ||
        this.head == "Email" ||
        this.head == "Onechat" ||
        this.head == "Webscript"
      ) {
        this.GetDetailSourceSystem();
      } else {
        this.GetDetailDashboard();
      }
    },
  },
  watch: {
    // Page(val) {
    //   // if (val == true) {
    //   //   this.DataList = this._detail;
    //   // }

    // },
  },
};
</script>
<style></style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
